import { render, staticRenderFns } from "./RegistrationStatusBadge.vue?vue&type=template&id=512513d7&"
import script from "./RegistrationStatusBadge.vue?vue&type=script&lang=js&"
export * from "./RegistrationStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports